
import { useNavigate } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";
import { CartItem } from "../../components/containers/cart-item";
import { useProduct } from "../../services/products/product.context";
import { FooterComponent } from "../../components/footer/footer";

export const Cartpage = () => {

    const { cart, addToCart, updateCartData } = useProduct();


    const navigateTo = useNavigate();


    //update cart data
    const totalInventory = cart?.reduce((sum, item) =>
        sum + (item?.pricing?.original_cost - item?.pricing?.original_cost * item?.pricing?.discount) * item.quantity, 0
    );

    const handleCheckout = () => {
        const productList = cart?.map((item) => {
            return {
                designation: item?.designation,
                quantity: item?.quantity,
                price:
                    (item?.pricing?.original_cost - item?.pricing?.original_cost * item?.pricing?.discount) * item.quantity
            }
        });
        navigateTo("/checkout", {
            state: {
                products: productList,
                total: totalInventory
            }
        })
        console.log({
            products: productList,
            total: totalInventory
        })
    }


    return (
        <div className="app-body">
            <SiteHeader pageTitle={'CART'} />
            <div style={{ minHeight: '100vh', paddingBottom: 60 }} >
                <div className="thin-text sp-3-st">Your Collection</div>
                <div className="slogan-1 sp-3-st">Shopping Cart</div>
                <div className="catalog">
                    {cart?.map((item) => {
                        return (
                            <CartItem
                                itemData={item}
                                removeFromCart={() => {
                                    addToCart(item);
                                    window.location.reload();
                                }}
                                addOne={() => updateCartData(item?._id, item?.quantity + 1)}
                                reduceOne={() => updateCartData(item?._id, item?.quantity - 1)}
                            />
                        )
                    })}
                </div>
                {cart?.length ?
                    <div className="cart-summary">
                        <div className="summary-unit">
                            <span className="sub-label">Delivery</span>
                            <span className="sub-word">Free</span>
                        </div>
                        <div className="summary-unit">
                            <span className="total-text">Total</span>
                            <span className="total-amount">{totalInventory.toLocaleString()}</span>
                        </div>
                    </div>

                    :
                    <div className="no-product sp-3-st">
                        <div className="slogan-2">No Products in cart</div>
                    </div>
                }
                {cart?.length > 0 && (
                    <div
                        className="order-button-box"
                        onClick={() => handleCheckout()}
                    >
                        <button className="final-order-button">Proceed to Checkout</button>
                    </div>
                )}
            </div>
            <FooterComponent />
        </div>
    )
}